import { Cookie, CookieKeys } from "../util/cookie";

let _firstPageView = true;
if (Cookie.get(CookieKeys.IsNewVisitor) == "false") {
    _firstPageView = false;
}
Cookie.set(CookieKeys.IsNewVisitor, "false", { expires: 365 });

export const isFirstPageView = () => {
    return _firstPageView;
}